import { useParams } from 'react-router'

import { nonEditableQuoteStatuses } from '@features/invoices/constants/nonEditableQuoteStatuses'
import { useFetchQuote } from '@features/invoices/hooks/useFetchQuote'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { InvoiceEditorUrlParams } from '../../../types/invoiceEditorUrlParams'
import { InvoiceEditorVariant } from '../enums/invoiceEditorVariant'
import { useInvoiceEditorVariant } from './useInvoiceEditorVariant'

interface UseQuoteEditorAccessResult {
  canAccessQuoteEditor: boolean
  isLoading: boolean
  redirectUrl?: string
}

export const useQuoteEditorAccess = (): UseQuoteEditorAccessResult => {
  const { organization } = useUserOrganization()
  const { documentId } = useParams<InvoiceEditorUrlParams>()
  const { invoiceEditorVariant } = useInvoiceEditorVariant()

  const isQuoteEdit = invoiceEditorVariant === InvoiceEditorVariant.QuoteEdit

  const {
    quote,
    isLoading: isLoadingQuote,
    isError: isErrorQuote,
    isSuccess: isSuccessQuote,
  } = useFetchQuote(isQuoteEdit ? documentId : undefined)

  const quoteStatus = quote?.status?.status
  const isLoading = isQuoteEdit && isLoadingQuote

  const canEditQuote = isSuccessQuote && !!quoteStatus && !nonEditableQuoteStatuses.includes(quoteStatus)
  const canAccessQuoteEditor = !isQuoteEdit || canEditQuote

  let redirectUrl: string | undefined
  if (isQuoteEdit) {
    if (isErrorQuote) {
      redirectUrl = getOrganizationViewUrl(organization?.url, reactRoute.organization.quotes.getMainRoute())
    } else if (!canEditQuote && documentId && !isLoadingQuote) {
      redirectUrl = getOrganizationViewUrl(
        organization?.url,
        reactRoute.organization.quotes.getViewQuoteRoute(documentId),
      )
    }
  }

  return { canAccessQuoteEditor, isLoading, redirectUrl }
}
